<div class="dashboard-container">
  <div class="text-center">
    <div class="row">
      <div class="col-lg-2 text-center"></div>

      <div class="col-lg-8 text-center">
        <app-time-clock />
      </div>

      <div class="col-lg-2 text-center">
        <app-dashboard-actions />
      </div>
    </div>

    <app-weather-next-hour-forecast />
    <app-weather-meteogram />
  </div>
</div>
